import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';
import { FinalSection } from 'src/app/shared/models/data/documentTemplate';
import { createDocumentEditor, DOCUMENT_TEMPLATE_TOOLBAR } from 'src/app/shared/ngx-editor/document-template-editor';

@Component({
  selector: 'app-final-section',
  templateUrl: './final-section.component.html',
  styleUrls: ['./final-section.component.scss']
})
export class FinalSectionComponent implements OnDestroy {
  @Input() reset!: () => void;
  @Input() finalSection: FinalSection = {
    section: {
      isModified: false,
      value: ''
    }
  };
  @Output() finalChange = new EventEmitter<FinalSection>();

  editor: Editor = createDocumentEditor();
  toolbar: Toolbar = DOCUMENT_TEMPLATE_TOOLBAR;

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  onEditorChange(newValue: string) {
    this.finalSection.section.value = newValue;
    this.finalSection.section.isModified = true;
    this.finalChange.emit(this.finalSection);
  }

}
